<template>
  <v-dialog :value="open" max-width="480" persistent>
    <v-card>
      <v-card-title>{{ $t('listaPreciosVenta.deleting') }}</v-card-title>
      <v-card-text>
        <p>{{ item.nombre }}</p>
        <v-alert v-if="error" type="error" dense>{{ error }}</v-alert>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="$emit('close')">{{ $t('common.cancel') }}</v-btn>
        <v-btn color="error" :loading="deleting" @click="confirm">{{ $t('common.delete') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ListaPreciosVentaProvider from "../../../providers/ListaPreciosVentaProvider";

export default {
  name: "ListaPreciosVentaDelete",
  props: { open: Boolean, item: { type: Object, required: true } },
  data() {
    return { deleting: false, error: null };
  },
  methods: {
    confirm() {
      this.deleting = true;
      this.error = null;
      ListaPreciosVentaProvider.delete(this.item.id)
        .then(() => this.$emit("itemDeleted"))
        .then(() => this.$emit("close"))
        .catch((err) => {
          this.error = err.message;
        })
        .finally(() => (this.deleting = false));
    },
  },
};
</script>
